import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing, theme} from '@logistics-frontend/blocks/theme/theme'
import {cssTheme} from '@logistics-frontend/blocks/v2'

export const classes = {
  button: css`
    height: ${spacing(4)};
    border-radius: 0;
    padding: 0;
    border: 0;
    outline: 0;
    cursor: pointer;
  `,
  titleText: css`
    display: flex;
    font-size: ${spacing(2.25)};
    justify-content: flex-start;
    flex-flow: row wrap;
    text-align: start;
  `,
  method: css`
    display: flex;
  `,
  methodText: css`
    ${theme.breakpoints.up('md')} {
      display: flex;
      justify-content: flex-end;
      &:hover {
        font-weight: ${cssTheme.fonts.weights.medium};
      }
    }
    display: none;
  `,
  helperText: css`
    color: ${theme.palette.error.main};
    text-align: left;
    padding: ${spacing(0, 1)};
  `,
  closeButton: css`
    margin-top: ${spacing(2)};
    &:hover {
      background-color: ${cssTheme.colors.yellow.toxic};
    }
  `,
  label: css`
    margin: 0;
    justify-content: space-between;
    border-bottom: 1px solid ${theme.palette.grey[300]};
  `,
  snackbar: css`
    ${theme.breakpoints.down('sm')} {
      top: ${spacing(0.8)};
      left: ${spacing(0.8)};
      right: ${spacing(0.8)};
      transform: none;
    }
  `,
}
